export default [
  [`Размеры`, `2XS`, `XS`, `S`, `M`, `L`],
  [`Российский размер`, `40`, `42`, `44`, `46`, `48`],
  [`Рост`, `164`, `164`, `170`, `170`, `170`],
  [`Обхват груди(a)`, `80`, `84`, `88`, `92`, `96`],
  [`Обхват бедер (b)`, `86`, `90`, `94`, `98`, `102`],
  [`Длина юбки c поясом (c)`, `44`, `46`, `46`, `46`, `48`],
  [`Ширина талии (d)`, `32`, `34`, `36`, `38`, `40`]
];
